export default __webpack_public_path__ + "static/media/the-cozy-one.bccfa9c4.jpg";